var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.11198 0.182345C0.863293 -0.066345 0.453583 -0.0598416 0.196871 0.196871C-0.0598416 0.453583 -0.066345 0.863293 0.182345 1.11198L3.9803 4.90994C4.03004 4.95968 4.03004 5.04032 3.9803 5.09006L0.182345 8.88802C-0.066345 9.13671 -0.0598416 9.54642 0.196871 9.80313C0.453583 10.0598 0.863293 10.0663 1.11198 9.81765L4.90994 6.0197C4.95968 5.96996 5.04032 5.96996 5.09006 6.0197L8.88802 9.81765C9.13671 10.0663 9.54642 10.0598 9.80313 9.80313C10.0598 9.54642 10.0663 9.13671 9.81765 8.88802L6.0197 5.09006C5.96996 5.04032 5.96996 4.95968 6.0197 4.90994L9.81765 1.11198C10.0663 0.863293 10.0598 0.453583 9.80313 0.196871C9.54642 -0.0598416 9.13671 -0.0663447 8.88802 0.182345L5.09006 3.9803C5.04032 4.03004 4.95968 4.03004 4.90994 3.9803L1.11198 0.182345Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.52d9545f606161149166c53d78fd7106.svg";
export { ForwardRef as ReactComponent };